import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';

@Component({
  selector: 'app-loadexam',
  templateUrl: './loadexam.component.html',
  styleUrls: ['./loadexam.component.scss']
})
export class LoadexamComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) {
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";

    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0)
      generalSvc.logoutUser();

    if (dataSvc.currentExamIndex == -1)
      generalSvc.loginUser();

    if (dataSvc.currentExam().Session.TimeTakenInSeconds > 0)
      this.resumeExam();
    
    if (dataSvc.currentUser.Exams[dataSvc.currentExamIndex].FrontPage == null)
      this.startExam();
  }

  ngOnInit() {
  }

  startExam() {
    this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].StatusText = "Started";
    this.initiateTimer();
    this.resumeExam();
  }

  initiateTimer(){
    var session = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session;
    var examTime = parseInt(session.AllotedTime) + parseInt(session.ExtraTime);
    var startTime = new Date();
    var endTime = new Date();
    endTime.setMinutes(endTime.getMinutes() + examTime);
    endTime = new Date(endTime);

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == null 
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted = startTime;
    }

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == null
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime = endTime;
    }    
  }

  resumeExam() {
    this.generalSvc.launchExamQuestions();
    this.dataSvc.startSyncMethods();
  }
}
